'use strict';

// ProductionPlant workspace — a producer's plant, owned by an Organization. Overview-only for now (plant approval
// join tables — ProductionPlantMaterialApproval / PlantMixApproval — are candidate childlists once their display
// columns are settled).
module.exports = {
	Identifier: 'ProductionPlantWorkspace', Ordinal: 254,
	Entity: { Name: 'ProductionPlant', IDField: 'IDProductionPlant', Collection: 'ProductionPlants', GUIDField: 'GUIDProductionPlant' },
	Header: { Eyebrow: 'Production Plant', Title: (r) => r.Name || `Production Plant ${r.IDProductionPlant}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/ProductionPlant/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'IDOrganization', Label: 'Organization', Card: 'Organization' }, { Key: 'ExternalProductionPlantID', Label: 'External ID', Mono: true }, { Key: 'Notes', Label: 'Notes', Wide: true } ] } ],
};
